import LabelValuePair from "./components/LabelValuePair";

function SwapOperationDetails({
  labelValueArr,
}: {
  labelValueArr: Array<{ label: string; value: string | number }>;
}) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      {labelValueArr.map((item) => (
        <LabelValuePair key={item.label} {...item} />
      ))}
    </div>
  );
}

export default SwapOperationDetails;
